import { FC } from "react";
import { choose, finalChoice } from "./ThreeDoorSolver";

type SummaryProps = React.HTMLAttributes<HTMLDivElement> & {
  choses: choose[];
}

const Summary:FC<SummaryProps> = ({choses, ...divProps}) => {

  const finalChoses = choses.map(finalChoice)
  const winrate = `${choses.map(c => finalChoice(c)).reduce((acc, e) => ((e.secret[e.answer.select] === "right") ? acc + 1 : acc), 0)*100/(choses.length > 0 ? choses.length : 1) }`

  return (
    <div {...divProps}>
        <table className="text-sm sm:text-base w-full">
          <thead>
            <tr className="text-mega-xs sm:text-base">
              <th></th>
              <th className="table-header-cell">was right</th>
              <th className="table-header-cell">1 selection</th>
              <th className="table-header-cell">2 selection</th>
              <th className="table-header-cell">wons</th>
            </tr>
          </thead>
          <tbody>
            <SummaryRow doors={[0]} finalChoses={finalChoses} firstChoses={choses}/>
            <SummaryRow doors={[1]} finalChoses={finalChoses} firstChoses={choses}/>
            <SummaryRow doors={[2]} finalChoses={finalChoses} firstChoses={choses}/>
            {/* <SummaryRow doors={[0,2]} name="not 2 door" finalChoses={finalChoses} firstChoses={choses}/> */}
            <SummaryRow doors={[0,1,2]} finalChoses={finalChoses} firstChoses={choses}/>
            <tr>
              <td colSpan={3}></td>
              <td className="capitalize text-right px-4 py-2">winrate</td>
              <td className="text-right px-4 py-2"> {winrate.slice(0, 4)}%</td>
            </tr>
          </tbody>
        </table>
      </div>
  );
}
export default Summary;

type SummaryRowProps = {
  doors: number[];
  firstChoses: choose[];
  finalChoses: choose[];
  name?: string;
}
export const SummaryRow: FC<SummaryRowProps> = ({doors, name, firstChoses, finalChoses}) => {
  const nam = name ? name : doors.length === 1 ? `door ${doors[0]+1}` : `Total`;
  const isTotal = doors.length === 3;
  return (
    <tr>
      <th className="text-mega-xs sm:text-base table-header-cell">{nam}</th>
      <td className="table-cell">
        {
          firstChoses.reduce(
            (acc, e) => 
              acc + doors.reduce( 
                (a2, ds) =>
                  a2 + (e.secret[ds] === "right" ? 1 : 0)
                , 0
              )
            , 0
          )
        }
      </td>

      {
        isTotal 
        ? <>
          <td></td>
          <td></td>
        </>
        : <>
          <td className="table-cell">
            {
              firstChoses.reduce(
                (acc, e) => 
                  acc + (doors.includes(e.answer.select) ? 1 : 0)
                , 0
              )
            }
          </td>
          <td className="table-cell">
            {
              finalChoses.reduce(
                (acc, e) => 
                  acc + (doors.includes(e.answer.select) ? 1 : 0)
                , 0
              )
            }
          </td>
        </>
      }

      <td className="table-cell">
        {
          finalChoses.reduce(
            (acc, e) => 
              acc + ((doors.includes(e.answer.select) && (e.secret[e.answer.select] === "right")) ? 1 : 0)
            , 0
          )
        }
      </td>
    </tr>
  );
}

